import { render, staticRenderFns } from "./loadingIcon.vue?vue&type=template&id=54ec3463&"
import script from "./loadingIcon.vue?vue&type=script&lang=js&"
export * from "./loadingIcon.vue?vue&type=script&lang=js&"
import style0 from "./loadingIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/vip/common/loadingIcon.vue
// module id = null
// module chunks = 